import {
  ActionReducerMapBuilder,
  AsyncThunk,
  Draft,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';

export function addAsyncCases<State, Payload>(
  builder: ActionReducerMapBuilder<State>,
  asyncActionCreator: AsyncThunk<Payload, unknown, {}>,
  reducer: (state: Draft<State>, action: PayloadAction<Resource<Payload | null>>) => void,
) {
  builder
    .addCase(asyncActionCreator.pending, (state, action) => {
      reducer(state, { ...action, payload: Resource.createPendingResource<Payload>() });
    })
    .addCase(asyncActionCreator.fulfilled, (state, action) => {
      reducer(state, {
        ...action,
        payload: Resource.createResolvedResource({ data: action.payload }),
      });
    })
    .addCase(asyncActionCreator.rejected, (state, action) => {
      if (!action.meta.aborted) {
        reducer(state, {
          ...action,
          payload: Resource.createRejectedResource({
            error: action.payload ?? (action.error as SerializedError),
          }),
        });
      }
    });
}
